import { Outlet } from 'react-router-dom';

export function CatalogPageLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

CatalogPageLayout.displayName = 'CatalogPageLayout';
